/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Automated_TitleInputs */

const en_privacy_automated_title = /** @type {(inputs: Privacy_Automated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Automated Decision-Making and AI Processing`)
};

const de_privacy_automated_title = /** @type {(inputs: Privacy_Automated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Automatisierte Entscheidungsfindung und KI-Verarbeitung`)
};

const fr_privacy_automated_title = /** @type {(inputs: Privacy_Automated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Prise de décision automatisée et traitement par IA`)
};

const es_privacy_automated_title = /** @type {(inputs: Privacy_Automated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Toma de decisiones automatizada y procesamiento de IA`)
};

const it_privacy_automated_title = /** @type {(inputs: Privacy_Automated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Processo decisionale automatizzato ed elaborazione AI`)
};

const nl_privacy_automated_title = /** @type {(inputs: Privacy_Automated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Geautomatiseerde besluitvorming en AI-verwerking`)
};

const pl_privacy_automated_title = /** @type {(inputs: Privacy_Automated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Zautomatyzowane podejmowanie decyzji i przetwarzanie AI`)
};

const fi_privacy_automated_title = /** @type {(inputs: Privacy_Automated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Automaattinen päätöksenteko ja tekoälykäsittely`)
};

const da_privacy_automated_title = /** @type {(inputs: Privacy_Automated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Automatisk beslutningstagning og AI-behandling`)
};

const sv_privacy_automated_title = /** @type {(inputs: Privacy_Automated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Automatiserat beslutsfattande och AI-bearbetning`)
};

/**
* | output |
* | --- |
* | "9. Automated Decision-Making and AI Processing" |
*
* @param {Privacy_Automated_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_automated_title = /** @type {((inputs?: Privacy_Automated_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Automated_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_automated_title(inputs)
	if (locale === "fr") return fr_privacy_automated_title(inputs)
	if (locale === "es") return es_privacy_automated_title(inputs)
	if (locale === "it") return it_privacy_automated_title(inputs)
	if (locale === "nl") return nl_privacy_automated_title(inputs)
	if (locale === "pl") return pl_privacy_automated_title(inputs)
	if (locale === "fi") return fi_privacy_automated_title(inputs)
	if (locale === "da") return da_privacy_automated_title(inputs)
	if (locale === "sv") return sv_privacy_automated_title(inputs)
	return en_privacy_automated_title(inputs)
});